export class LoginBaseModel {
    token: string;
    version = 2;
    groupInviteMode = 0;
    groupInviteKey: string;
    groupCodeMode = 0;
    groupCode: string;

    constructor () { }
}
